"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _InfoIcon = _interopRequireDefault(require("./InfoIcon"));

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MetricsFilters = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MetricsFilters, _React$Component);

  function MetricsFilters() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleMeasureChange", function (event, data) {
      _this.props.updateSelectedMeasure(data.value);
    });

    return _this;
  }

  var _proto = MetricsFilters.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        showMeasure = _this$props.showMeasure,
        selectedMeasure = _this$props.selectedMeasure,
        singleView = _this$props.singleView;
    var measureOptions = [{
      key: 'index',
      value: 'index',
      text: 'Index'
    }, {
      key: 'population',
      value: 'population',
      text: 'Population'
    }, {
      key: 'shareOfSegment',
      value: 'shareOfSegment',
      text: "Share Of " + singleView
    }, {
      key: 'shareOfProperty',
      value: 'shareOfProperty',
      text: 'Share Of Attribute'
    }];
    return /*#__PURE__*/React.createElement("div", null, showMeasure ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "metrics-filter"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "metrics-filter__title"
    }, "Measure", /*#__PURE__*/React.createElement(_InfoIcon["default"], null, /*#__PURE__*/React.createElement("p", null, "Four measures are available."), /*#__PURE__*/React.createElement("p", null, "Index is the propensity to possess an attribute, in comparison to the complete data set, and is expressed as a value based to 100. A value of 200, therefore, would indicate a ", singleView, " is twice as likely as the general population to possess the attribute."), /*#__PURE__*/React.createElement("p", null, "Share of ", singleView, " is the the percentage of the", ' ', singleView, " that possess the attribute."), /*#__PURE__*/React.createElement("p", null, "Share of Attribute is the percentage who belong to the", singleView, ", among all who possess that attribute."), /*#__PURE__*/React.createElement("p", null, "Population is self-explanatory, although the universe may vary as appropriate for the attribute (for instance, voting or drinking would be in terms of those aged over 18)."))), /*#__PURE__*/React.createElement(_semanticUiReact.Dropdown, {
      name: "measureFilter",
      className: "metrics-filter__dropdown",
      value: selectedMeasure ? selectedMeasure : 'index',
      selection: true,
      options: measureOptions,
      onChange: this.handleMeasureChange
    })), /*#__PURE__*/React.createElement("hr", {
      className: "metrics-filter__divider"
    })) : '');
  };

  return MetricsFilters;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    pluralView: state.audienceView.view.textPlural,
    singleView: state.audienceView.view.textSingular
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, undefined)(MetricsFilters);

exports["default"] = _default;